<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import * as echarts from "echarts";
import chartResize from "./mixins/chart-resize";

export default {
  name: "BarEchart3",
  mixins: [chartResize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "柱状图",
    },
    chartData: {
      type: Object,
      required: true,
    },
    xAxisName: {
      type: String,
      default: "日期",
    },
    yAxisName: {
      type: String,
      default: "数量",
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.chart.clear();
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el);
      this.setOptions(this.chartData);
    },
    setOptions() {
      this.chart.setOption({
        color: ["rgba(80, 177, 113, 1)", "rgba(200, 65, 65, 1)"],
        legend: {
          bottom: "1%",
          itemWidth: 10,
          itemHeight: 8,
          itemGap: 15,
          textStyle: {
            fontFamily: "MicrosoftYaHei",
            fontSize: 10,
            color: "rgba(178, 175, 173, 1)",
          },
          data: ["正常", "故障"],
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          backgroundColor: "rgba(42, 51, 74, 0.89)",
          borderColor: "transparent",
          confine: true,
        },
        grid: {
          left: "3%",
          top: "3%",
          right: "5%",
          bottom: "20%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          name: "个",
          nameTextStyle: {
            fontFamily: "MicrosoftYaHei",
            fontSize: 12,
            color: "rgba(113, 113, 113, 1)",
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(52, 51, 51, 1)",
            },
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            margin: 5,
            fontFamily: "MicrosoftYaHei",
            fontSize: 10,
            color: "rgba(113, 113, 113, 1)",
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: "category",
          data: this.chartData.name,
          interval: true,
          axisLine: {
            lineStyle: {
              color: "rgba(52, 51, 51, 1)",
            },
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            margin: 10,
            fontFamily: "MicrosoftYaHei",
            fontSize: 12,
            color: "#9ab9ca",
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            name: "正常",
            type: "bar",
            stack: "truck",

            itemStyle: {
              borderColor: "transparent",
              borderWidth: 3,
            },
            label: {
              show: false,
            },
            data: this.chartData.count2,
          },

          {
            name: "故障",
            type: "bar",
            stack: "truck",

            itemStyle: {
              borderColor: "transparent",
              borderWidth: 3,
            },
            label: {
              show: false,
            },
            data: this.chartData.count1,
          },
        ],
      });
    },
  },
};
</script>
